import { React, Component } from 'react'
import Steps from '../../../components/Steps/Steps';
import { Redirect } from 'react-router-dom';

import PaymentBoleto from '../../../components/PaymentBoleto/PaymentBoleto';
import SelectedPlan from '../../../components/SelectedPlan/SelectedPlan';

class Boleto extends Component {
    constructor(props){
        super(props);

        this.state = {
            step: 3
        }

    }

    render() {

        if(!localStorage.getItem("token")){
            return (
                <Redirect to="/" />
            )
        }

        return(
            <div className="page-container page">

                <SelectedPlan />

                <div className="position-relative">
                    <div className="p-5">

                        <PaymentBoleto />
                        
                    </div>
                </div>
            </div>
        )

    }
}

export default Boleto;